export default "__VITE_ASSET__025e54e9__"